export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  //SIGNUP: '/sign-up',
  SIGNUP: '/sign-up',
  SIGN_UP_TRAVELER: '/sign-up/traveler',
  SIGN_UP_GREETER: '/sign-up/greeter',
  SIGNUP_GREETER: '/sign-up-greeter',
  CONFIRMEMAIL: '/confirm-email',
  NEW_PASSWORD: '/new-password',
  AWAITINGCONFIRMATION: '/awaiting-confirmation',
  //QUESTIONNAIRE: '/define-your-journey',
  QUESTIONNAIRE: '/define-your-journey',
  QUESTIONNAIRENEXT: '/define-your-journey/next',
  QUESTIONNAIREFINISH: '/define-your-journey/finish',
  BOOKINGSTEPONE: '/booking-step-one',
  BOOKINGSTEPTWO: '/booking-step-two',
  ADDITIONAL_REQUIREMENTS: '/additional-requirements',
  BOOKINGSTEPTHREE: '/booking-step-three',
  CHECKOUT: '/booking-checkout',
  BOOKINGCONFIRMED: '/booking-confirmed',
  MYPROFILE: '/my-profile',
  PRIVACY_POLICY: '/privacy-policy',
  FAQGREETER: '/faq-greeter',
  FAQTRAVELER: '/faq-traveler',
  CANCELLATIONPOLICY: '/cancellation-policy',
  NON_FOUND: '/not-found',
  SOLO_TRAVEL_GROUPS: '/solo-travel-groups', // Nueva ruta para el embudo de conversión
  SOLO_FEMALE_TRAVEL: '/solo-female-travel', // Nueva ruta para el embudo SEO
  SOLO_TRIPS_FOR_WOMEN: '/solo-trips-for-women', // Nueva ruta para el embudo SEO de viajes en solitario para mujeres
  SOLO_FEMALE_TRAVELER: '/solo-female-traveler', // Nueva ruta para el embudo SEO específico para viajeras solitarias
  TERMS_AND_CONDITIONS: '/terms-and-conditions',
  BOOKING_PROPOSAL: '/booking-proposal/:bookingId',
  MARRAKESH: '/private-female-guide-marrakesh', // Hub de destino — embudo SEO Marrakesh
  MARRAKESH_FR: '/fr/guide-privee-femme-marrakech', // Idem en FR — mercado emisor #1 de Marruecos
  MARRAKESH_ES: '/es/guia-privada-mujer-marrakech', // Idem en ES — mercado emisor #2
  MARRAKESH_DE: '/de/private-reisefuehrerin-marrakesch', // DE — ojo: en alemán la ciudad es «Marrakesch»
  MARRAKESH_IT: '/it/guida-privata-donna-marrakech', // IT — el mercado que más creció hacia Marruecos
  MARRAKESH_NL: '/nl/vrouwelijke-prive-gids-marrakech', // NL — Países Bajos y Bélgica
  MARRAKESH_SV: '/sv/kvinnlig-privatguide-marrakech', // SV — sol invernal nórdico, cola larga
  MARRAKESH_NO: '/no/kvinnelig-privatguide-marrakech', // NO — idem
  MARRAKESH_DA: '/da/kvindelig-privatguide-marrakech', // DA — idem
  MARRAKESH_PT: '/pt/guia-privada-mulher-marrakech', // PT — corredor Lisboa-Marrakech, 297 vuelos semanales
  WOMEN_APPROVED_HOTELS: '/women-approved-hotels', // Greether Approved — Hotel Partner Program
  BRAND_KIT_PARTNERS: '/brand-kit-partners', // Media kit — deck de partnerships para marcas, hoteles y destinos
  EARLY_TESTER: '/greether-early-tester', // Descarga de la beta (TestFlight / Play). Noindex hasta el lanzamiento público
} as const;
